import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { map } from 'rxjs/operators';
import { getAuthAccountDetails } from '@aaa/emember/store-membership';
import { Pages } from '../../../constants/pages';

export const validAccountDetails: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store.select(getAuthAccountDetails).pipe(
    map((accountDetails) => {
      if (!accountDetails) {
        router.navigateByUrl(Pages.account);

        return false;
      }

      return true;
    }),
  );
};

export default validAccountDetails;
